export default function AniversariosSustentarePage() {
  const photos = [
    {
      id: 1,
      image: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20anniversary%20celebration%20with%20employees%20celebrating%20company%20milestone%20together%2C%20modern%20office%20party%20setting%20with%20blue%20and%20white%20decorations%2C%20team%20gathering%20with%20happy%20colleagues%2C%20business%20celebration%20event%20with%20food%20and%20drinks%2C%20warm%20festive%20atmosphere%2C%20professional%20photography%20style&width=800&height=600&seq=aniv-sustentare-1&orientation=landscape',
      caption: 'Celebração do aniversário da Sustentare'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20lunch%20buffet%20celebration%20with%20employees%20enjoying%20delicious%20food%20together%2C%20modern%20catering%20setup%20with%20blue%20and%20white%20theme%2C%20professional%20team%20dining%20event%2C%20business%20anniversary%20lunch%20party%2C%20elegant%20food%20presentation%2C%20warm%20ambient%20lighting&width=800&height=600&seq=aniv-sustentare-2&orientation=landscape',
      caption: 'Almoço especial para toda equipe'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20awards%20ceremony%20with%20employees%20receiving%20prizes%20and%20recognition%2C%20modern%20office%20celebration%20event%20with%20blue%20and%20white%20decorations%2C%20professional%20team%20achievement%20recognition%2C%20business%20anniversary%20awards%20presentation%2C%20happy%20colleagues%20celebrating%20success&width=800&height=600&seq=aniv-sustentare-3&orientation=landscape',
      caption: 'Premiação dos colaboradores'
    },
    {
      id: 4,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20celebration%20with%20colleagues%20laughing%20and%20enjoying%20company%20anniversary%20party%2C%20modern%20office%20environment%20with%20festive%20decorations%20in%20blue%20and%20white%2C%20professional%20group%20photo%20of%20happy%20employees%2C%20business%20celebration%20gathering%2C%20warm%20friendly%20atmosphere&width=800&height=600&seq=aniv-sustentare-4&orientation=landscape',
      caption: 'Momentos de confraternização'
    },
    {
      id: 5,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20anniversary%20cake%20cutting%20ceremony%20with%20employees%20gathered%20around%2C%20modern%20office%20celebration%20with%20blue%20and%20white%20theme%2C%20professional%20team%20celebrating%20company%20milestone%2C%20business%20party%20with%20elegant%20cake%20presentation%2C%20festive%20joyful%20atmosphere&width=800&height=600&seq=aniv-sustentare-5&orientation=landscape',
      caption: 'Momento do parabéns'
    },
    {
      id: 6,
      image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20building%20activities%20during%20company%20anniversary%20celebration%2C%20modern%20office%20event%20with%20employees%20participating%20in%20fun%20activities%2C%20blue%20and%20white%20color%20scheme%2C%20professional%20team%20engagement%2C%20business%20celebration%20with%20interactive%20games%2C%20energetic%20happy%20atmosphere&width=800&height=600&seq=aniv-sustentare-6&orientation=landscape',
      caption: 'Atividades e integração'
    }
  ];

  const highlights = [
    {
      icon: 'ri-restaurant-line',
      title: 'Almoço Especial',
      description: 'Buffet completo preparado especialmente para celebrar nosso aniversário'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Premiações',
      description: 'Reconhecimento aos colaboradores que se destacaram durante o ano'
    },
    {
      icon: 'ri-team-line',
      title: 'Confraternização',
      description: 'Momentos de integração e celebração entre toda a equipe'
    },
    {
      icon: 'ri-gift-line',
      title: 'Surpresas',
      description: 'Brindes e lembranças especiais para todos os colaboradores'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20corporate%20anniversary%20celebration%20with%20large%20group%20of%20employees%20celebrating%20company%20milestone%20together%2C%20modern%20office%20party%20atmosphere%20with%20blue%20and%20white%20decorations%2C%20professional%20team%20gathering%20with%20festive%20environment%2C%20business%20celebration%20event%20with%20balloons%20and%20banners%2C%20warm%20celebratory%20lighting%2C%20joyful%20professional%20atmosphere&width=1920&height=1080&seq=hero-aniv-sustentare&orientation=landscape"
            alt="Aniversários Sustentare"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <span className="inline-block px-6 py-2 bg-blue-600 text-white text-sm font-medium rounded-full mb-6">
            Endomarketing Sustentare
          </span>
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Aniversários Sustentare</h1>
          <p className="text-xl md:text-2xl font-light">
            Celebrando nossos marcos com quem faz a diferença: nossa equipe
          </p>
        </div>
      </section>

      {/* Introdução */}
      <section className="py-20 px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Uma Celebração Especial</h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            Cada aniversário da Sustentare é uma oportunidade de celebrar nossas conquistas e, principalmente, 
            reconhecer o trabalho dedicado de cada colaborador. Com um almoço especial, premiações e momentos 
            de confraternização, fortalecemos os laços que fazem da nossa empresa um lugar único para trabalhar.
          </p>
          <p className="text-lg text-gray-600 leading-relaxed">
            Esta é uma ação de endomarketing que valoriza nosso time e reforça nossa cultura organizacional, 
            mostrando que cada pessoa é fundamental para o nosso sucesso.
          </p>
        </div>
      </section>

      {/* Destaques */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Destaques do Evento</h2>
            <p className="text-lg text-gray-600">
              Momentos especiais que marcaram nossa celebração
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {highlights.map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg text-center hover:shadow-xl transition-shadow">
                <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                  <i className={`${item.icon} text-4xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Galeria de Fotos */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Galeria de Momentos</h2>
            <p className="text-lg text-gray-600">
              Reviva os melhores momentos da nossa celebração
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {photos.map((photo) => (
              <div
                key={photo.id}
                className="group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div className="aspect-[4/3] overflow-hidden">
                  <img
                    src={photo.image}
                    alt={photo.caption}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <p className="text-white text-lg font-medium">{photo.caption}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-4 bg-gradient-to-br from-blue-600 to-blue-700">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold text-white mb-6">
            Pessoas & Cultura Sustentare
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            São as pessoas que garantem a qualidade, a segurança e a confiança em cada produto que entregamos.
          </p>
          <button
            onClick={() => window.REACT_APP_NAVIGATE('/')}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            Voltar para Home
          </button>
        </div>
      </section>
    </div>
  );
}
